import { Box, Divider } from '@mui/material';
import React from 'react';

import { CorePlan, PremiumPlan, TeamsPlan } from './components';

const SubscriptionPlans: React.FC = () => {
    return (
        <Box className="grid grid-cols-1 lg:grid-cols-[1fr_1px_1fr] xl:grid-cols-[1fr_1px_1fr_1fr] gap-9 my-8 mx-auto px-5 max-w-[1300px] w-full">
            <CorePlan />
            <Divider
                className="hidden lg:block"
                orientation="vertical"
                flexItem
            />
            <PremiumPlan />
            <TeamsPlan />
        </Box>
    );
};

export default SubscriptionPlans;
